export const numberIsBetween = (num: number, min: number, max: number) => {
  return num >= min && num <= max;
};
